import Lightbox from "../modules/lightbox";

const singlePart = {
  init() {
    Lightbox.load();
    Lightbox.events();
    singlePart.events();
  },

  events() {
    $(".btn--modal").on("click", (e) => {
      let screenWidth = $(window).width();

      let imgID;
      if (screenWidth < 600) {
        imgID = $(e.currentTarget).data("img-mobile");
      } else {
        imgID = $(e.currentTarget).data("img");
      }
      Lightbox.openModal(imgID);
    });
  },

};

export default singlePart;
